import React from 'react';
import BaseView from '../../components/CRUDView';
import {FarmersEndpoints, FBOEndpoints, TractorRequestEndpoints, USSDEndpoints} from "../../common/ProxyEndpoints";
import Avatar from '../../components/ProfileAvatar';
import {Badge, Button} from 'reactstrap';
import EntityImageDisplay from '../../components/EntityImageDisplay';
import Spinner from 'react-spinkit';
import Utils from "../../common/Utils";
import {Dialogs, GenderMap, Permissions} from "../../common/Constants";
import AppVariables from "../../common/AppVariables";
import FarmersCommon, {CustomFarmersFilter, FARMERS_QUERY_FILTERS, parseFarmerQueryFilters} from "./FarmersCommon";
import _ from 'lodash';
import HTML from '../../common/HtmlHelpers';
import StandardValue from "../../common/StandardValue";
import FarmSizeLabel, {FARM_SIZE_LABEL, FARM_SIZE_PROPERTY} from "../../common/FarmSizeLabel";
import {getDistricts, getLocationRecord, getWards, listProvinces} from "../../data/locations";
import TractorRequestBuilder from "../../components/TractorRequestBuilder/TractorRequestBuilder";
import convertUnit from "convert-units/lib";

const SearchProps = [
    'name' ,
    'phone' ,
    'email',
    'farm_location',
    FARM_SIZE_PROPERTY,
];


class FarmersFBO extends BaseView {

    constructor(props){
        super(props,'farmers_fbo');
    }

    getFBOId(){
        return this.proxy.getUserInfo().fbo.id;
    }

    fetchUSSDServices() {
        const endpoint = USSDEndpoints.getUSSDServices();
        return this.proxy.processRequest(endpoint,{
            include: ["pricing"]
        }).then(response => response.getPayload());
    }


    beforeShowDialog(dialog,state) {

        if(dialog === Dialogs.CreateOrEdit){

            const editItem = state ? state.editItem : null;
            const _provinceList = listProvinces();
            const _selectProvince = (editItem ? editItem.province : "" );
            const _districtList = _selectProvince ? getDistricts(_selectProvince) : [];
            const _selectDistrict = (editItem ? editItem.district : "" );
            const _wardList = (_selectProvince && _selectDistrict) ? getWards(_selectProvince,_selectDistrict) : [];

            return this.setStateSafe({
                _locationMode: state.editItem && (state.editItem.province && state.editItem.district && state.editItem.ward) ? 'select' : 'custom',
                _selectProvince,
                _selectDistrict,
                _provinceList,
                _districtList,
                _wardList
            }, () => super.beforeShowDialog(dialog));
        }

        return super.beforeShowDialog(dialog);
    }

    getCustomFilterState(filters) {
        return parseFarmerQueryFilters(filters);
    }

    onCreateRequest(){

        const form = this._createRequestForm;
        const { service, token , ...formData } = form.getFormData(true);

        return this.proxy.processRequest( TractorRequestEndpoints.createTractorRequest(service,formData,token , this.getFBOId() ) ).then(response => {

            //  hide dialog
            this._addRequest.hide();

            HTML.toastMessage("Tractor request service made successfully!");

        }).catch(ex => {

            form.updateException(ex);

        });

    }

    renderDialogs(dialog) {

        return <React.Fragment>
            {super.renderDialogs(dialog)}

            <TractorRequestBuilder
                fetchFarmers={params => (this.proxy.processRequest({
                    ...FBOEndpoints.getFBOFarmers(this.getFBOId()),
                    ...params
                }))}
                onBuildRequest={() => {

                return {
                    query: {
                        fbo: this.getFBOId()
                    }
                };

            }} ref={r => this._addRequest = r}/>

        </React.Fragment>
    }


    componentWillMount(){

        const me = this;

        this.setViewOptions({

            //  The message to show when there are no items in the view
            noRowsMessage: 'No farmers available yet!',

            //  The class icon for the card header
            pageIcon: 'fa fa-user',

            //  The title for the content frame
            pageTitle: 'Farmers',

            //  The total number of items per page
            maxItemsPerPage: AppVariables.MaxItemsPerPage,

            //  Defines the features of the view
            features: [ 'toolbox' , 'search' ],

            multiSelection: {

                //  enable multi-selection
                enable : true,
            },

            hooks: {

                //  Fetch Query Hooks
                preQueryHook: () => {
                    return me.fetchUSSDServices().then(services =>{

                        return {
                            services: services
                        };

                    })
                }

            },

            //  defines (CRUD) actions enabled on the items
            actions:{

                //  create action options
                create: {
                    enabled: true,
                    text: 'Add Farmer',
                    successCreateMsg: 'Farmer added successfully!',
                    failCreateMsg : 'Failed adding farmer!',
                    editTitleMsg: 'Edit Farmer',
                    createTitleMsg: 'Add Farmer',
                    permissions:  [ Permissions.Farmers.Create ]
                },

                //  delete action options
                delete:{

                    enabled : false,

                    //  Disallows the deleting of many items ??
                    disallowMany: false,

                    successDeleteMsg: 'Deleted successfully!',
                    failDeleteMsg: 'Failed deleting',
                    text: 'Delete',
                    confirmTitle: 'Confirm Delete',
                    confirmMessage: 'Are you sure you want to delete farmer?',

                    //  The message to show when deleting many items
                    confirmManyMessage: 'Delete selected farmers?',
                    permissions:  [ Permissions.Farmers.Remove ]
                },

                //  edit options
                edit:{
                    enabled : true,
                    successEditMsg: 'Farmer edited successfully!',
                    failEditMsg: 'Failed editing farmer',
                    text: 'Edit Farmer',
                    permissions:  [ Permissions.Farmers.Update ]
                }

            },

            queryActions: {

                //  The endpoint for query actions
                endpoint: FBOEndpoints.getFBOFarmers( this.getFBOId() ).url,
                endpointSingle: FBOEndpoints.getUrl()

            },



            model:{
                include: [ 'media', 'user' ]
            },

            filters: Utils.excludeFilters(FARMERS_QUERY_FILTERS,[ 'fbo.id', 'fboName' ]),

            renderCustomFilters: (props) => <CustomFarmersFilter includeFBO={false} {...props}/>,

            search:{

                placeholder: 'Search farmers...',

                //  the mode for searching
                //  immediate: responsive
                //  explicit: wait till user hits the search button
                mode: 'explicit',

                //  The minimum characters to begin search with
                minSearchChars: 2,

                //  Search properties
                properties: SearchProps

            },

            sort: {

                properties: [
                    {
                        label: "Date Added",
                        value: "date_created"
                    },
                    {
                        label: "Name",
                        value: "name"
                    },
                    {
                        label: "Phone",
                        value: "phone"
                    },
                    {
                        label: FARM_SIZE_LABEL,
                        value: FARM_SIZE_PROPERTY
                    }
                ]

            },

            //  Defines actions for toolbox
            toolBox: [

                //  ACTIONS
                {  text : 'Add Farmer'  , icon : 'fa fa-plus'  , invoke: () => { me.beginShowDialog({activeDialog: 0 }); }  , position: 'right' , permissions:  [ Permissions.Farmers.Create ] },
                {  text : 'Refresh'  , icon : 'fa fa-refresh'  , invoke: () => me.refresh() , position: 'right' },
                {  text : 'Gender'  , icon : 'fa fa-male' , invoke: (index) => { me.updateQuery('sex',index,true) }, position: 'right' , group : 'filter' , items: GenderMap },
                {  text : null  , icon : 'fa fa-sort' , invoke: (index) => { me.configureSort();  }, position: 'right' , group : 'filter'},
                {  text : ''  , icon : 'fa fa-gears' , invoke: (index) => {

                        switch (index){
                            case 0:
                                me.toggleCustomFilterVisibility();
                                break;
                        }

                    }, position: 'right' , group : 'more' ,
                    items: () => ([
                        <span><i className={me.isCustomFilterViewVisible() ? "fa fa-chevron-up" : "fa fa-chevron-down"}/> {me.isCustomFilterViewVisible() ? "Hide" : "Show"} Advanced Filters</span>
                    ]),
                    sticky: false,
                }
            ],

            //  Inputs used in editing and creating items
            inputs: () => FarmersCommon.getFarmerInputs(undefined,{
                locationMode: this.state._locationMode,
                onLocationModeChange: mode => {
                    this.setStateSafe({ _locationMode: mode })
                },
                provinces: this.state._provinceList,
                districts: this.state._districtList,
                wards: this.state._wardList,
                onProvinceChanged: value => {

                    const _districtList = value ? getDistricts(value) : [];
                    const _selectDistrict = _districtList.length > 0 ? _districtList[0].value : "";
                    const _wardList =  _selectDistrict ? getWards(value,_selectDistrict) : [];
                    const _selectWard = _wardList.length > 0 ?  _wardList[0].value : "";

                    this.setState({
                        _selectProvince: value,
                        _selectDistrict,
                        _districtList,
                        _wardList
                    },() => {

                        const renderer  = this.getDialogRenderer(Dialogs.CreateOrEdit);
                        renderer.setInputValueWithName('district', _selectDistrict );
                        renderer.setInputValueWithName('ward', _selectWard);

                    });

                },
                onDistrictChanged: value => {

                    const _wardList = getWards(this.state._selectProvince,value);
                    const _selectWard = _wardList[0].value;

                    this.setState({
                        _selectDistrict: value,
                        _wardList
                    }, () => {

                        const renderer  = this.getDialogRenderer(Dialogs.CreateOrEdit);
                        renderer.setInputValueWithName('ward', _selectWard);

                    });

                }
            }),
            // Describes the columns present in the table
            columns : [
                {   key: '__img' , label: ' ' , cell: (item,k) => <Avatar src={item.media.count > 0 ? item.media.sources[0].path.static : null}  name={Utils.formatAvatarName(item.name)}  size={32} /> , mobile: true },
                {   key: 'name', label: () => me.sortCol("Name","name") , format: 'trimmed' , mobile: true},
                {   key: 'phone', label: () => me.sortCol("Phone","phone"), format: 'trimmed', mobile: true },
                {   key: FARM_SIZE_PROPERTY , label: () => me.sortCol("Farm Size",FARM_SIZE_PROPERTY), cell: (item,k) => <StandardValue value={item[k]}><FarmSizeLabel value={item[k]}/></StandardValue>}
            ],

            //  Describes details to show when clicked
            detailsDisplay: {

                //  enable or disable
                enabled: true,

                renderTitle: (item) => {
                    return 'Farmer Info';
                },

                customRender: (item) => {

                    const me = this;
                    return <div>
                        <div className="text-center">
                            <h5>Profile Image</h5>
                            <EntityImageDisplay
                                entityName="farmer"
                                entityId={item.id}
                                crudView={me}
                                onRemove={(media) => {
                                    me.updateItemMedia(item,media);
                                }}
                                onCompleteUpload={(media) => {
                                    me.updateItemMedia(item,media);
                                    return false;
                                }}
                                media={item.media} />
                        </div>

                        <div>
                            <div className="clearfix">
                                <div className="pull-left">
                                    <h5>Info</h5>
                                </div>
                                <div className="pull-right">
                                    {me.state.isBusy && <Spinner name="ball-scale-multiple" color="black" style={{marginRight: '30px'}}/>}
                                </div>
                            </div>
                            <hr/>

                            <div className="row">

                                <div className="col-md-6">
                                    <dl>
                                        <dt>Name</dt>
                                        <dl>{item.name}</dl>

                                        <dt>Phone</dt>
                                        <dl>{item.phone}</dl>

                                        <dt>Sex</dt>
                                        <dl>{(!_.isNil(item.sex)) ? GenderMap[item.sex] : "N/A" }</dl>

                                        <dt>Email</dt>
                                        <dl>{Utils.standardValue(item.email)}</dl>

                                        <dt>Date Of Birth</dt>
                                        <dl>
                                            <StandardValue value={item.date_of_birth}>
                                                {Utils.formatDateShort(item.date_of_birth)}
                                            </StandardValue>
                                        </dl>

                                        <dt>Crop(s)</dt>
                                        <dl>{item.crop ? item.crop.split(",").map( (m,k) => <Badge key={k} pill={true} style={{marginRight: 5}}>{m}</Badge>) : "N/A" }</dl>

                                    </dl>
                                </div>

                                <div className="col-md-6">
                                    <dl>

                                        <dt>Farm Size</dt>
                                        <dl>
                                            <StandardValue value={item[FARM_SIZE_PROPERTY]}>
                                                <FarmSizeLabel item={item}/>
                                            </StandardValue>
                                        </dl>

                                        <dt>Location</dt>
                                        <dl>{item.farm_location ? item.farm_location :  (item.province && item.district && item.ward ? [item.province,item.district,item.ward].join(',') : '' ) || "N/A" }</dl>

                                        <dt>Date Added</dt>
                                        <dl>{Utils.formatDateStandard(item.date_created)}</dl>

                                        <dt>User Account Status</dt>
                                        <dl><h6>{item.user ? <Badge pill color={"success"}>Registered <i className="fa fa-check"/></Badge> : <Badge pill color={"secondary"}>Not Registered</Badge>}</h6></dl>

                                    </dl>
                                </div>
                            </div>

                            {<Button disabled={!me.state.isLoaded || me.state.faulted} block={true} color={"green"} style={{borderRadius: 5}} onClick={() => {

                                //  hide dialog
                                me.toggleDialog(true);

                                //
                                window.setTimeout(() => this._addRequest.show({ farmer: item }), 410);

                            }}><i className="fa fa-plus"></i> Request Tractor Service</Button>}

                        </div>
                    </div>

                }
            },

            //  Processors
            processors:{

                //  create new item
                createItem: (proxy , payload) => {

                    if(payload.province && payload.district && payload.ward){

                        const loc = getLocationRecord(payload);
                        if(loc){
                            payload.farm_location = [payload.province,payload.district,payload.ward].join(",");
                            payload.farm_location_lat = loc.lat;
                            payload.farm_location_long = loc.lng;
                        }

                    }

                    //  select only required properties
                    return proxy.processRequest(FarmersEndpoints.create( me.getFBOId() ,payload));
                },

                //  on edit item
                onEditItem: (proxy,item, formData, affected ) => {

                    //
                    if(affected.hasOwnProperty(FARM_SIZE_PROPERTY)){
                        let _value = affected[FARM_SIZE_PROPERTY] || null;
                        affected[FARM_SIZE_PROPERTY] = _value;

                        if(FARM_SIZE_PROPERTY === 'acres'){
                            affected.hectares = convertUnit(_value).from('ac').to('ha');
                        }
                        else if(FARM_SIZE_PROPERTY === 'hectares'){
                            affected.acres = convertUnit(_value).from('ha').to('ac');
                        }
                    }

                    if(affected.province || affected.district || affected.ward){

                        const loc = getLocationRecord(formData);
                        if(loc){
                            affected.farm_location = [formData.province,formData.district,formData.ward].join(",");
                            affected.farm_location_lat = loc.lat;
                            affected.farm_location_long = loc.lng;
                        }


                    }

                    //
                    if(Object.keys(affected).find(x => affected[x] !== undefined)) {
                        affected.last_updated = item.last_updated;
                        return proxy.processRequest(FarmersEndpoints.update(item.id, affected));
                    }
                    else{
                        return Promise.resolve();
                    }

                },

                //  on delete item
                onDeleteItem: ( proxy,item) => {
                    return proxy.processRequest(FarmersEndpoints.deleteFarmer(item.id));
                },

                //  called to delete many items
                deleteMany: (proxy,items) =>{
                    return proxy.processRequest(FarmersEndpoints.deleteFarmer(items.map((f) => f.id)));
                }


            }
        });

    }


}

export default FarmersFBO;


// WEBPACK FOOTER //
// ./src/views/Farmers/FarmersFBO.js